import { useClickOutside } from "@hoylu/client-common";
import React, { useCallback, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  selectUserMarbleColor,
  selectUserProfile,
} from "../state/user/user.selector";
import { selectEffectiveTonnageUsage } from "../state/workspaces/workspaces.selector";
import { CircularProgressBar } from "./CircularProgressBar";
import UserProfileMarble from "./UserProfileMarble";
import UserProfileMenu from "./UserProfileMenu";
import Styles from "./UserProfileWidget.module.css";

export const UserProfileWidget = () => {
  const profile = useSelector(selectUserProfile);
  const effectiveTonnageUsage = useSelector(selectEffectiveTonnageUsage);
  const userColor = useSelector(selectUserMarbleColor);

  const [profileOpen, setProfileOpen] = useState(false);

  const toggleProfileOpen = useCallback(
    () => setProfileOpen((profileOpen) => !profileOpen),
    [],
  );

  const clickOutsideHandler = useCallback(() => {
    setProfileOpen(false);
  }, []);

  const profileButtonRef = useRef<HTMLButtonElement | null>(null);
  const outsideListenerRef = useClickOutside(clickOutsideHandler, [
    profileButtonRef,
  ]);

  return (
    <div className={Styles.userProfileWidget}>
      <button
        className={Styles.marbleButton}
        onClick={toggleProfileOpen}
        ref={profileButtonRef}
        type="button"
      >
        <CircularProgressBar
          percentage={effectiveTonnageUsage}
          themeColor={userColor}
        >
          <UserProfileMarble profile={profile} userColor={userColor} />
        </CircularProgressBar>
        <div className={Styles.userName}>
          <div>{profile.firstName}</div>
          <div>{profile.lastName}</div>
        </div>
      </button>
      {profileOpen && (
        <div className={Styles.userProfileContainer} ref={outsideListenerRef}>
          <UserProfileMenu />
        </div>
      )}
    </div>
  );
};

export default UserProfileWidget;
